<template>
    <div>
      <b-card no-body class="mb-0">
      <div v-if="$store.getters['containerAreaPlan.list/isLoading']" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>

      <filters />

      <div class="m-2">
        <b-row>
          <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <v-select 
                :value="$store.getters['containerAreaPlan.list/perPage']"
                @input="value => {
                  $store.commit('containerAreaPlan.list/updatePerPage', { value })
                  $store.dispatch('containerAreaPlan.list/fetchList')
                }"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="$store.getters['containerAreaPlan.list/perPageOptions']"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"/>
            <label>{{ $t('entries') }}</label>
          </b-col>

          <b-col cols="12" md="9">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input 
                @input="(value)=> {
                  $store.commit('containerAreaPlan.list/updateSearchQuery', { value } )
                  $store.dispatch('containerAreaPlan.list/fetchList')
                }"
                :value="$store.getters['containerAreaPlan.list/sreachQuery']"
                class="d-inline-block mr-1" 
                :placeholder="$t('Search...')" 
              />
              <b-button 
                v-if="$store.getters['auth/user'].permissions.includes('plans.containerArea.create')" 
                variant="primary" 
                :to="{ name: 'plans.containerArea.create' }"
              >
                <span class="text-nowrap"> {{ $t('PLANS_CREATE_LABEL')}}</span>
              </b-button>

              <b-button 
                class="mr-1 ml-1" 
                variant="info" 
                @click.prevent="()=> $store.dispatch('containerAreaPlan.list/exportPDF')" 
                type="button"
              >
                {{ $t('Export PDF') }}
              </b-button>

              <b-button 
                @click.prevent="()=> $store.dispatch('containerAreaPlan.list/exportXLSX')" 
                type="button" 
                class="mr-1 ml-1" 
                variant="info"
              >
                {{ $t('Export Excel') }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
  
      <b-table 
        :items="$store.getters['containerAreaPlan.list/list']" 
        :fields="$store.getters['containerAreaPlan.list/tableColumns']"
        class="position-relative" 
        primary-key="id"
        empty-text="No matching records found"
        show-empty
        responsive
        >
  
        <template #cell(id)="data"> {{ data.index + 1 }} </template>
  
        <template #cell(actions)="data">
  
          <b-dropdown 
            class="actionIcon" 
            variant="link" 
            no-caret 
            :right="$store.state.appConfig.isRTL"
            v-if="($store.getters['auth/user'].permissions.includes('plans.containerArea.edit')) || 
            ($store.getters['auth/user'].permissions.includes('plans.containerArea.destroy'))" 
          >
  
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body"/>
            </template>
  
            <b-dropdown-item 
            :to="{ name: 'plans.containerArea.edit', params: { id: data.item.id } }"
              v-if="($store.getters['auth/user'].permissions.includes('plans.containerArea.edit'))" 
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('PLANS_EDIT_LABEL') }}</span>
            </b-dropdown-item>

            <b-dropdown-item 
              @click='() => $store.dispatch("containerAreaPlan.list/delete" , {id:data.item.id})'
              v-if="($store.getters['auth/user'].permissions.includes('plans.containerArea.destroy'))" 
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">{{ $t('PLANS_DELETE_LABEL') }}</span>
            </b-dropdown-item>
  
          </b-dropdown>
        </template>
  
      </b-table>
  
      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">{{ $store.getters['containerAreaPlan.list/tableMeta'] }}</span>
          </b-col>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination 
                :value="$store.getters['containerAreaPlan.list/currentPage']"
                @input="value => {
                  $store.commit('containerAreaPlan.list/updateCurrentPage', { value })
                  $store.dispatch('containerAreaPlan.list/fetchList')
                }"
                :total-rows="$store.getters['containerAreaPlan.list/tableTotalRows']"
                :per-page="$store.getters['containerAreaPlan.list/perPage']" 
                first-number 
                last-number
                class="mb-0 mt-1 mt-sm-0" 
                prev-class="prev-item" 
                next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18"/>
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18"/>
              </template>
            </b-pagination>
  
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>

import {
  BCard, 
  BRow, 
  BCol, 
  BFormInput, 
  BButton, 
  BTable, 
  BMedia, 
  BAvatar, 
  BLink,
  BBadge, 
  BDropdown, 
  BDropdownItem, 
  BPagination,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'

import { onUnmounted } from '@vue/composition-api'

import store from '@/store'
import storeModule from '@/app/plans/containerArea/list.store.js'

import filters from './filters.vue'


export default {
  components: {
    OrbitSpinner,
    filters,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia, 
    BAvatar, 
    BLink, 
    BBadge, 
    BDropdown, 
    BDropdownItem, 
    BPagination,
    vSelect,
  },
  setup(props, { root }) {

    if(!store.hasModule('containerAreaPlan.list')){
      store.registerModule('containerAreaPlan.list', storeModule)
    }

    onUnmounted(() => {
      if (store.hasModule('containerAreaPlan.list')){
        store.unregisterModule('containerAreaPlan.list')
      }
    })

    store.commit('containerAreaPlan.list/updateRoot', root)
    store.dispatch('containerAreaPlan.list/fetchFiltersOptions')
    store.dispatch('containerAreaPlan.list/fetchList')

    return {}

  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.per-page-selector {
  width: 90px;
}
.actionIcon > button {
  padding: 0;
}
.table > tbody > tr > td {
max-width:200px;

}


</style>
